import 'react';
import { Box, Text, Table } from 'reaxl';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
function RatesTable(_ref) {
  let {
    ratesData,
    selectedLoanTerm
  } = _ref;
  if (ratesData.length < 2) return null; // we need at least one rate in addition to the best rate to display the comparison table

  const ratesDataCopy = [...(ratesData || [])].sort((a, b) => b.rate - a.rate);
  const {
    name: lenderName,
    rate: rateValue
  } = ratesDataCopy.pop();
  const rates = ratesDataCopy.slice(0, 4).map(rate => ({
    ...rate,
    rateDifference: (rate.rate - rateValue).toFixed(2)
  }));
  return /*#__PURE__*/jsxs(Box, {
    className: "text-center text-size-300 margin-top-2 margin-top-sm-3",
    backgroundColor: "neutral-secondary",
    borderColor: "transparent",
    children: [/*#__PURE__*/jsx(Text, {
      weight: "bold",
      componentClass: "div",
      children: `${lenderName} offers a ${selectedLoanTerm} mo. financing rate of ${rateValue}%`
    }), /*#__PURE__*/jsx(Text, {
      color: "subdued-lighter",
      children: "Compare it to other lenders"
    }), /*#__PURE__*/jsxs(Table, {
      condensed: true,
      borderless: true,
      className: "text-left margin-top-2 margin-bottom-0 w-100",
      "data-cmp": "ratesComparisonTable",
      children: [/*#__PURE__*/jsx("thead", {
        children: /*#__PURE__*/jsxs("tr", {
          children: [/*#__PURE__*/jsx(Text, {
            componentClass: "th",
            className: "padding-vertical-0",
            color: "subdued-lighter",
            weight: "normal",
            children: "Lender"
          }), /*#__PURE__*/jsx(Text, {
            componentClass: "th",
            className: "text-nowrap text-right padding-vertical-0",
            color: "subdued-lighter",
            weight: "normal",
            children: "Rate, Difference"
          })]
        })
      }), /*#__PURE__*/jsx("tbody", {
        children: rates?.map(_ref2 => {
          let {
            name,
            rate,
            rateDifference
          } = _ref2;
          return /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx("td", {
              className: "padding-vertical-0",
              children: name
            }), /*#__PURE__*/jsx("td", {
              className: "text-right padding-vertical-0",
              children: rateDifference === '0.00' ? `${(Math.round(rate * 100) / 100).toFixed(2)}%, equal` : /*#__PURE__*/jsxs(Fragment, {
                children: [`${(Math.round(rate * 100) / 100).toFixed(2)}%,\u00A0`, /*#__PURE__*/jsx(Text, {
                  color: "danger",
                  children: `+${rateDifference}%`
                })]
              })
            })]
          }, name);
        })
      })]
    })]
  });
}
export { RatesTable as default };
